module.exports = __webpack_public_path__ + "static/img/Schedule-amico.d78d08f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/Schedule-amico.png
// module id = YcVh
// module chunks = 3